import React, { useState } from 'react';
import { Certificate } from 'cccisd-laravel-assignment';
import Modal from 'cccisd-modal';

const CertificateRender = ({ certProps }) => {
    // used to make network requests do not happen until Certificate modal is opened
    const [isOpen, setIsOpen] = useState(false);

    return (
        <Modal
            trigger={
                <button type="button" className="btn btn-primary">
                    View Certificate
                </button>
            }
            beforeShow={() => setIsOpen(true)}
            afterClose={() => setIsOpen(false)}
            title={'Certificate for ' + certProps.forceName}
        >
            {isOpen ? <Certificate {...certProps} /> : <span />}
        </Modal>
    );
};

export default CertificateRender;
